/**
 * Skool.com-formatted markdown exporter.
 * Maps the 10 playbook block slugs to their Skool section headers.
 * All Skool About / Rules / Classroom / etc fields accept standard markdown.
 */

const SLUG_TO_HEADER = {
  "name-tagline": null, // top-level H1, handled specially
  "about-public": "## About",
  "welcome-free": "## Welcome (Free)",
  "welcome-paid": "## Welcome (Paid)",
  rules: "## Rules",
  sections: "## Sections",
  classroom: "## Classroom",
  "first-week": "## First Week",
  pricing: "## Pricing",
  "onboarding-emails": "## Onboarding Emails",
};

// Section-specific body normalization to make lifts cleaner.
function transformBody(slug, body) {
  const raw = (body || "").trim();
  if (!raw) return "";
  switch (slug) {
    case "first-week":
      // Prepend **Day N** markers if the model wrote plain "Day 1:" etc.
      return raw.replace(/^\s*Day\s+(\d+)[\s:—-]+/gim, "**Day $1** — ");
    case "onboarding-emails":
      // Bold "Subject:" lines so each email's subject stands out.
      return raw.replace(/^\s*Subject:\s*/gim, "**Subject:** ");
    default:
      return raw;
  }
}

/**
 * Turn one block into a Skool-ready markdown chunk.
 * If slug === "name-tagline", parses NAME\nTAGLINE and returns "# NAME\n> TAGLINE".
 */
export function blockToSkoolMarkdown(block) {
  if (!block) return "";
  const body = transformBody(block.slug, block.body || "");
  if (!body) return "";
  if (block.slug === "name-tagline") {
    const lines = body.split("\n").filter(Boolean);
    const name = (lines[0] || "Coastal Roots Botanica").trim();
    const tag = (lines[1] || "").trim();
    return tag ? `# ${name}\n> ${tag}` : `# ${name}`;
  }
  const header = SLUG_TO_HEADER[block.slug];
  return header ? `${header}\n\n${body}` : `## ${block.title}\n\n${body}`;
}

/**
 * Assemble the full Skool playbook markdown from the 10 blocks.
 * Preserves the order given (which the backend returns in spec order).
 */
export function assembleSkoolMarkdown(blocks) {
  const parts = (blocks || [])
    .map((b) => blockToSkoolMarkdown(b))
    .filter((s) => s && s.length);
  return parts.join("\n\n---\n\n");
}
